
export const icaoRegex = /A\)\s?([A-Z]{4})/;
export const grfIcaoRegex = /SNOWTAM [0-9]{4}\s([A-Z]{4})/;
export const dateTimeRegex = /B\)\s?([0-9]{8})/;
export const grfDayTimeRegex = /([0-9]{8})/;
export const rwyRegex = /(C\)\s?.*)(?=C\)|R\)|S\)|T\)|$|\))/mg;
export const grfRwyRegex = /[0-9]{8} [0-9]{2}[0-9A-Z/ ]*/gi;

export const rwyIdentRegex = /C\)\s?(.*?) (?= [A-Z]\)|$||\))/;
export const grfRwyIdentRegex = /[0-9]{8} ([0-9A-Z]*)/;
export const grfRwyContaminants = /[0-9]{8} [0-9A-Z]* (.*)/;
export const grfRwyContaminantsGroups = /[0-9A-Z]*\/[0-9A-Z]*\/[0-9A-Z]*|[A-Z ]{3,}\/[A-Z ]{3,}\/[A-Z ]{3,}|[0-9]{1,3}/g;
export const grfSituationalAwarenessSection = /[\n]{2}([\s\S]*)\)/;
export const rwyClearedLengthRegex = /D\)\s?(.*?)(?= [A-Z]\)|$|\))/;
export const rwyClearedWidthRegex = /E\)\s?(.*?)(?= [A-Z]\)|$|\))/;
export const depositsRegex = /F\)\s?(.*?)(?= [A-Z]\)|$)/;
export const depthOfDepositsRegex = /G\)\s?(.*?)(?= [A-Z]\)|$|\))/;
export const snowbanksRegex = /J\)\s?(.*?)(?= [A-Z]\)|$|\))/;
export const rwyLightsRegex = /K\)\s?(.*?)(?= [A-Z]\)|$|\))/;
export const clearingStartRegex = /L\)\s?(.*?)(?= [A-Z]\)|$|\))/;
export const clearingEndRegex = /M\)\s?(.*?)(?= [A-Z]\)|$|\))/;
export const taxiWaysRegex = /N\)\s?(.*?)(?= [A-Z]\)|$|\))/;

export const frictionRegex = /H\)\s?(\d{1,2}\/\d{1,2}\/\d{1,2})(?= [A-Z]\)| ([A-Z]{3})|$|\))/;

export const apronRegex = /R\)\s?(.*?)(?= [A-Z]\)|$|\))/;
export const nextPlannedObservationRegex = /S\)\s?(.*?)(?= [A-Z]\)|$|\))/;
export const remarksRegex = /T\)\s?(.*?)(?= [A-Z]\)|$|\))/;
